import * as React from "react"

type LocationData = {
  id: string
  database: string
}

function parseLocation(loc: unknown): LocationData {
  const parsed = typeof loc === "string" ? JSON.parse(loc) : loc
  return parsed as LocationData
}

export default function useOnSelectWindowMessage(
  onClose: () => void = () => undefined,
  onSelect: (location: LocationData) => void = () => undefined
) {
  React.useEffect(() => {
    function onIManageMessage(evt: MessageEvent) {
      if (evt.data.type === "cancel") return onClose()

      if (evt?.data?.type === "select") {
        onSelect(parseLocation(evt.data.data.output_data.loc))
      }
    }

    window.addEventListener("message", onIManageMessage, false)

    return () => window.removeEventListener("message", onIManageMessage, false)
  }, [onClose, onSelect])
}
